/* Home — FAQ: topic tabs + single-open accordion. */
(function () {
  var TYPE = 'home-faq';

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var b = item.querySelector('.hf-item__q');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  var rt;
  function refreshLater() {
    clearTimeout(rt);
    rt = setTimeout(function () { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); }, 520);
  }

  function init(root) {
    if (!root || root._hf) return;
    root._hf = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-faq-tab]'));
    var lists = Array.prototype.slice.call(root.querySelectorAll('[data-faq-list]'));

    function pick(cat, animate) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-faq-tab') === cat;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      lists.forEach(function (l) {
        var on = l.getAttribute('data-faq-list') === cat;
        l.hidden = !on;
        if (on) {
          var items = Array.prototype.slice.call(l.querySelectorAll('[data-faq-item]'));
          items.forEach(function (it, i) { setOpen(it, i === 0); });
          var D = window.Dozzee || {};
          if (animate && window.gsap && !D.reduce) {
            window.gsap.from(items, { y: 18, opacity: 0, stagger: 0.05, duration: 0.5, ease: 'power3.out', clearProps: 'transform,opacity' });
          }
        }
      });
      refreshLater();
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.classList.contains('is-on')) return;
        pick(t.getAttribute('data-faq-tab'), true);
      });
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.hf-item__q');
      if (!b || !root.contains(b)) return;
      var item = b.closest('[data-faq-item]'), list = item.parentNode, open = !item.classList.contains('is-open');
      Array.prototype.forEach.call(list.querySelectorAll('[data-faq-item]'), function (it) { setOpen(it, false); });
      setOpen(item, open);
      refreshLater();
    });

    if (tabs.length) {
      var first = root.querySelector('[data-faq-tab].is-on') || tabs[0];
      var cat = first.getAttribute('data-faq-tab');
      var l = root.querySelector('[data-faq-list="' + cat + '"]');
      if (!l || l.hidden || !l.children.length) pick(tabs[0].getAttribute('data-faq-tab'), false);
    }
  }

  function all(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-section-type="' + TYPE + '"]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('[data-faq-item]');
    var root = e.target.closest && e.target.closest('[data-section-type="' + TYPE + '"]');
    if (!item || !root) return;
    var list = item.closest('[data-faq-list]'), tab = root.querySelector('[data-faq-tab="' + list.getAttribute('data-faq-list') + '"]');
    if (tab && !tab.classList.contains('is-on')) tab.click();
    Array.prototype.forEach.call(list.querySelectorAll('[data-faq-item]'), function (it) { setOpen(it, it === item); });
  });
})();
